import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  labelText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    fontWeight: 500,
    marginBottom: 5,
    textAlign: 'center',
  },
}));
